import { useCallback, useEffect, useState } from 'react';
import type { SafetyLocationLookups } from '../utils/locationDisplay';
import { loadSiteLocationLookups } from '../utils/loadSiteLocationLookups';

export type SiteLocationLookupsResult = SafetyLocationLookups & {
  refresh: () => void;
};

/** Load site display name + active camera placements for Safety location UX. */
export function useSiteLocationLookups(
  siteId: string,
  enabled = true,
): SiteLocationLookupsResult {
  const [lookups, setLookups] = useState<SafetyLocationLookups>({});
  const [refreshToken, setRefreshToken] = useState(0);
  const refresh = useCallback(() => setRefreshToken((n) => n + 1), []);

  useEffect(() => {
    const scoped = String(siteId || '').trim();
    if (!enabled || !scoped) {
      setLookups({});
      return;
    }
    let cancelled = false;
    loadSiteLocationLookups(scoped)
      .then((next) => {
        if (!cancelled) setLookups(next);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, siteId, refreshToken]);

  return { ...lookups, refresh };
}
